/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Days_Fixed_MixedInputs */

const en_us2_onboarding_days_fixed_mixed = /** @type {(inputs: Onboarding_Days_Fixed_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A bit of both`)
};

const pt_br2_onboarding_days_fixed_mixed = /** @type {(inputs: Onboarding_Days_Fixed_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um pouco dos dois`)
};

const es_419_onboarding_days_fixed_mixed = /** @type {(inputs: Onboarding_Days_Fixed_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un poco de ambos`)
};

const pt_pt2_onboarding_days_fixed_mixed = /** @type {(inputs: Onboarding_Days_Fixed_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um pouco de ambos`)
};

const fr_fr2_onboarding_days_fixed_mixed = /** @type {(inputs: Onboarding_Days_Fixed_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un peu des deux`)
};

const de_de2_onboarding_days_fixed_mixed = /** @type {(inputs: Onboarding_Days_Fixed_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein bisschen von beidem`)
};

const it_it2_onboarding_days_fixed_mixed = /** @type {(inputs: Onboarding_Days_Fixed_MixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un po' tutte e due`)
};

/**
* | output |
* | --- |
* | "A bit of both" |
*
* @param {Onboarding_Days_Fixed_MixedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_days_fixed_mixed = /** @type {((inputs?: Onboarding_Days_Fixed_MixedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Days_Fixed_MixedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_days_fixed_mixed(inputs)
	if (locale === "es-419") return es_419_onboarding_days_fixed_mixed(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_days_fixed_mixed(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_days_fixed_mixed(inputs)
	if (locale === "de-DE") return de_de2_onboarding_days_fixed_mixed(inputs)
	if (locale === "it-IT") return it_it2_onboarding_days_fixed_mixed(inputs)
	return en_us2_onboarding_days_fixed_mixed(inputs)
});
export { onboarding_days_fixed_mixed as "onboarding.days_fixed.mixed" }